var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-wrapper",style:(_vm.isMediumSize?'padding: 36px 0':'')},[_c('div',{staticClass:"step-content",style:(_vm.isMediumSize?'padding: 0 100px;transform: scale(1.4)':'')},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }